export default __webpack_public_path__ + "static/media/MacRA-Design_COMPLETE-LOGO-negative.bb001ed7.png";